import "./base/gsap";

import { runDefault, runLayoutDefault, runComponentDefault, runModuleDefault } from "./utils/runner-functions";

import { initVariables } from "./utils/variables";
import { initScroller, requestScrollTriggerRefresh } from "./base/scroll";
import { runLoader } from "./base/loader";

async function init() {
    initGlobalScripts();
    initLayoutScripts();
    initComponentScripts();
    initModuleScripts();

    await runLoader();
    // Animations after loader
    runComponentDefault("motion");

    requestAnimationFrame(() => requestScrollTriggerRefresh(250));

    // Prevent Lenis from scrolling on the cookie modal
    document.querySelector(".moove-gdpr-tab-main-content")?.setAttribute("data-lenis-prevent", "");
}

function initGlobalScripts() {
    initVariables();
    initScroller();
    runDefault("grid");
    runDefault("link-prefetch");
}

function initLayoutScripts() {
    runLayoutDefault("header");
    runLayoutDefault("footer");
    runLayoutDefault("get-in-touch");
}

function initComponentScripts() {
    runComponentDefault("credit", ".credit");
    runComponentDefault("btn-hover", ".btn-hover");
    runComponentDefault("spotlight", ".spotlight");
    runComponentDefault("mask", "[data-mask]");
    runComponentDefault("number-flow", "number-flow");
    runComponentDefault("customers-marquee", ".customers-marquee");
    runComponentDefault("accordion", ".accordion");
}

function initModuleScripts() {
    runModuleDefault("quick-links", ".quick-links");
    runModuleDefault("cards-carousel", ".cards-carousel");
    runModuleDefault("key-milestones", ".key-milestones");
    runModuleDefault("sector-detail", ".sector-detail");
    runModuleDefault("sector-hero", ".sector-hero");
    runModuleDefault("map", ".map");
    runModuleDefault("team-list", ".team-list");
    runModuleDefault("project-hero", ".project-hero");
    runModuleDefault("benefits", ".benefits");
    runModuleDefault("filter", ".filter-bar, .filter-modal");
    runModuleDefault("team-modal", ".team-modal");
    runModuleDefault("post", ".post");
}

function safeInit() {
    requestAnimationFrame(() => setTimeout(init, 1));
}

if (!(document.readyState === "loading")) safeInit();
else document.addEventListener("DOMContentLoaded", safeInit);
